module.exports = __webpack_public_path__ + "img/levelNeedle5Degree1Int.b62b2343.svg";